(() => {
  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  qa('[data-auto-submit]').forEach((field) => {
    field.addEventListener('change', () => field.form && field.form.submit());
  });

  qa('[data-ranked-tabs]').forEach((component) => {
    const buttons = qa('[data-tab-target]', component);
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });
        qa('.ranked-panel', component).forEach((panel) => panel.classList.toggle('is-active', panel.id === button.dataset.tabTarget));
      });
    });
  });

  qa('[data-quantity-minus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = q('input[type="number"]', button.parentElement);
      if (input) input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
  });
  qa('[data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = q('input[type="number"]', button.parentElement);
      if (input) input.value = Number(input.value || 1) + 1;
    });
  });

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  const likesStorageKey = 'pwm:product-likes:v1';
  const heartIcon = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5 3.75 12.6A5.36 5.36 0 0 1 12 5.88a5.36 5.36 0 0 1 8.25 6.72L12 20.5Z"/></svg>';

  const normalizeLike = (item) => {
    if (!item || typeof item !== 'object' || !item.handle) return null;

    return {
      handle: String(item.handle),
      title: String(item.title || item.handle),
      url: String(item.url || `/products/${item.handle}`),
      vendor: String(item.vendor || ''),
      price: String(item.price || ''),
      priceCents: Number(item.priceCents || 0),
      image: String(item.image || '')
    };
  };

  const readLikes = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(likesStorageKey) || '[]');
      if (!Array.isArray(stored)) return [];

      const seen = new Set();
      return stored
        .map(normalizeLike)
        .filter((item) => {
          if (!item || seen.has(item.handle)) return false;
          seen.add(item.handle);
          return true;
        });
    } catch (_) {
      return [];
    }
  };

  const writeLikes = (likes) => {
    try {
      localStorage.setItem(likesStorageKey, JSON.stringify(likes.slice(0, 100)));
    } catch (_) {
      // Likes remain optional when local storage is unavailable.
    }
  };

  const formatLikePrice = (item) => {
    if (item.price) return item.price;
    if (!item.priceCents) return '';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'JPY'
      }).format(item.priceCents / 100);
    } catch (_) {
      return `${(item.priceCents / 100).toFixed(2)}`;
    }
  };

  const updateLikeButton = (button, isLiked) => {
    const title = button.dataset.likeTitle || 'THIS PRODUCT';
    button.classList.toggle('is-liked', isLiked);
    button.setAttribute('aria-pressed', isLiked ? 'true' : 'false');
    button.setAttribute('aria-label', `${isLiked ? 'REMOVE' : 'ADD'} ${title} ${isLiked ? 'FROM' : 'TO'} YOUR LIKES`);
    button.title = isLiked ? 'REMOVE FROM YOUR LIKES' : 'ADD TO YOUR LIKES';
  };

  const syncLikeButtons = (scope = document, likes = readLikes()) => {
    const handles = new Set(likes.map((item) => item.handle));
    const buttons = [];

    if (scope.matches?.('[data-like-button]')) buttons.push(scope);
    buttons.push(...qa('[data-like-button]', scope));

    buttons.forEach((button) => {
      updateLikeButton(button, handles.has(button.dataset.likeHandle || ''));
    });
  };

  const createLikedProductCard = (item) => {
    const article = document.createElement('article');
    article.className = 'liked-product-card';

    const mediaWrap = document.createElement('div');
    mediaWrap.className = 'liked-product-card__media-wrap';

    const mediaLink = document.createElement('a');
    mediaLink.className = 'liked-product-card__media';
    mediaLink.href = item.url;
    mediaLink.setAttribute('aria-label', item.title);

    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      image.width = 900;
      image.height = 1125;
      mediaLink.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'liked-product-card__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      mediaLink.appendChild(placeholder);
    }

    const removeButton = document.createElement('button');
    removeButton.className = 'product-card__like is-liked';
    removeButton.type = 'button';
    removeButton.innerHTML = heartIcon;
    removeButton.dataset.likeButton = '';
    removeButton.dataset.likeHandle = item.handle;
    removeButton.dataset.likeTitle = item.title;
    removeButton.dataset.likeUrl = item.url;
    removeButton.dataset.likeVendor = item.vendor;
    removeButton.dataset.likePrice = item.price;
    removeButton.dataset.likePriceCents = String(item.priceCents || 0);
    removeButton.dataset.likeImage = item.image;
    updateLikeButton(removeButton, true);

    mediaWrap.append(mediaLink, removeButton);

    const info = document.createElement('div');
    info.className = 'liked-product-card__info';

    if (item.vendor) {
      const vendor = document.createElement('div');
      vendor.className = 'product-card__vendor';
      vendor.textContent = item.vendor;
      info.appendChild(vendor);
    }

    const title = document.createElement('a');
    title.className = 'liked-product-card__title';
    title.href = item.url;
    title.textContent = item.title;
    info.appendChild(title);

    const formattedPrice = formatLikePrice(item);
    if (formattedPrice) {
      const price = document.createElement('div');
      price.className = 'liked-product-card__price';
      price.textContent = formattedPrice;
      info.appendChild(price);
    }

    article.append(mediaWrap, info);
    return article;
  };

  const renderYourLikes = (likes = readLikes()) => {
    const section = q('[data-your-likes]');
    if (!section) return;

    const grid = q('[data-your-likes-grid]', section);
    const count = q('[data-your-likes-count]', section);
    if (!grid) return;

    grid.replaceChildren(...likes.map(createLikedProductCard));
    section.hidden = likes.length === 0;
    if (count) count.textContent = likes.length ? `(${likes.length})` : '';
  };

  const announceLikeChange = (message) => {
    const status = q('[data-likes-status]');
    if (!status) return;
    status.textContent = '';
    requestAnimationFrame(() => { status.textContent = message; });
  };

  const initializeLikes = (scope = document) => {
    const likes = readLikes();
    syncLikeButtons(scope, likes);
    renderYourLikes(likes);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-like-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.likeHandle || '';
    if (!handle) return;

    const likes = readLikes();
    const existingIndex = likes.findIndex((item) => item.handle === handle);
    const wasLiked = existingIndex !== -1;

    if (wasLiked) {
      likes.splice(existingIndex, 1);
    } else {
      likes.unshift(normalizeLike({
        handle,
        title: button.dataset.likeTitle,
        url: button.dataset.likeUrl,
        vendor: button.dataset.likeVendor,
        price: button.dataset.likePrice,
        priceCents: button.dataset.likePriceCents,
        image: button.dataset.likeImage
      }));
    }

    const cleanLikes = likes.filter(Boolean);
    writeLikes(cleanLikes);
    syncLikeButtons(document, cleanLikes);
    renderYourLikes(cleanLikes);
    announceLikeChange(`${button.dataset.likeTitle || 'Product'} ${wasLiked ? 'removed from' : 'added to'} your likes.`);
  });

  window.addEventListener('storage', (event) => {
    if (event.key === likesStorageKey) initializeLikes();
  });

  initializeLikes();

  const initializeProductCarousels = (scope = document) => {
    const carousels = [];

    if (scope.matches?.('[data-product-carousel]')) carousels.push(scope);
    carousels.push(...qa('[data-product-carousel]', scope));

    carousels.forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const track = q('[data-product-gallery]', carousel);
      const items = qa('[data-media-index]', carousel);
      const previous = q('[data-carousel-previous]', carousel);
      const next = q('[data-carousel-next]', carousel);
      const current = q('[data-carousel-current]', carousel);
      const thumbnails = qa('[data-carousel-thumb]', carousel);

      if (!track || items.length === 0) return;

      carousel.dataset.carouselReady = 'true';
      let activeIndex = 0;
      let scrollFrame = 0;

      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(index, items.length - 1));

        if (current) current.textContent = String(activeIndex + 1);
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === items.length - 1;

        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const isActive = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        thumbnails[activeIndex]?.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      };

      const goTo = (index, behavior = prefersReducedMotion ? 'auto' : 'smooth') => {
        const target = items[Math.max(0, Math.min(index, items.length - 1))];
        if (!target) return;

        track.scrollTo({
          left: target.offsetLeft,
          behavior
        });
        setActive(Number(target.dataset.mediaIndex || index));
      };

      const updateFromScroll = () => {
        scrollFrame = 0;
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - trackCenter);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        if (nearestIndex !== activeIndex) setActive(nearestIndex);
      };

      track.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateFromScroll);
      }, { passive: true });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          goTo(Number(thumbnail.dataset.carouselThumb || 0));
        });
      });

      carousel.addEventListener('product:select-media', (event) => {
        goTo(Number(event.detail?.index || 0));
      });

      setActive(0);
    });
  };

  initializeProductCarousels();

  const initializeSizeCharts = (scope = document) => {
    const triggers = [];
    const dialogs = [];

    if (scope.matches?.('[data-size-chart-open]')) triggers.push(scope);
    triggers.push(...qa('[data-size-chart-open]', scope));

    if (scope.matches?.('[data-size-chart-dialog]')) dialogs.push(scope);
    dialogs.push(...qa('[data-size-chart-dialog]', scope));

    triggers.forEach((trigger) => {
      if (trigger.dataset.sizeChartReady === 'true') return;

      const dialog = document.getElementById(trigger.dataset.sizeChartOpen || '');
      if (!dialog) return;

      trigger.dataset.sizeChartReady = 'true';
      trigger.addEventListener('click', () => {
        document.documentElement.classList.add('size-chart-open');

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });

    dialogs.forEach((dialog) => {
      if (dialog.dataset.sizeChartReady === 'true') return;
      dialog.dataset.sizeChartReady = 'true';

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          document.documentElement.classList.remove('size-chart-open');
        }
      };

      q('[data-size-chart-close]', dialog)?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('size-chart-open');
      });
    });
  };

  initializeSizeCharts();

  qa('[data-product-root]').forEach((root) => {
    const json = q('[data-product-variants]', root);
    const form = q('[data-product-form]', root);
    if (!json || !form) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }
    const optionGroups = qa('[data-option-index]', form);
    const idInput = q('[data-variant-id]', form);
    const addButton = q('[data-add-to-cart]', form);
    const addText = q('[data-add-to-cart-text]', form);
    const price = q('[data-product-price]', root);
    const compare = q('[data-compare-price]', root);
    const formatMoney = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'JPY' }).format(cents / 100); }
      catch (_) { return `${(cents / 100).toFixed(2)}`; }
    };
    const update = () => {
      const selected = optionGroups.map((group) => q('input:checked', group)?.value || '');
      optionGroups.forEach((group) => {
        const label = q('[data-selected-option]', group);
        const checked = q('input:checked', group);
        if (label && checked) label.textContent = checked.value;
      });
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
        compare.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const url = new URL(root.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.featured_media) {
        const media = q(`[data-media-id="${variant.featured_media.id}"]`, root);
        const carousel = media?.closest('[data-product-carousel]');
        const mediaIndex = Number(media?.dataset.mediaIndex || 0);

        if (carousel) {
          carousel.dispatchEvent(new CustomEvent('product:select-media', {
            detail: { index: mediaIndex }
          }));
        }
      }
    };
    optionGroups.forEach((group) => qa('input', group).forEach((input) => input.addEventListener('change', update)));
  });

  const isThemeEditor = document.documentElement.classList.contains('shopify-design-mode');

  const initializeInfiniteScroll = (scope = document) => {
    const containers = [];

    if (scope.matches?.('[data-infinite-scroll]')) containers.push(scope);
    containers.push(...qa('[data-infinite-scroll]', scope));

    containers.forEach((container) => {
      if (container.dataset.infiniteReady === 'true') return;

      const collectionPage = container.closest('[data-collection-page]');
      const grid = q('[data-infinite-grid]', collectionPage || document);
      const loadButton = q('[data-infinite-load]', container);
      const sentinel = q('[data-infinite-sentinel]', container);
      const status = q('[data-infinite-status]', container);

      if (!grid) return;

      container.dataset.infiniteReady = 'true';

      let nextUrl = container.dataset.nextUrl || '';
      let loading = false;
      let loadedCount = 1;
      let infiniteObserver = null;

      if (collectionPage) collectionPage.dataset.loadedCount = String(loadedCount);

      const setStatus = (message = '', hidden = false) => {
        if (!status) return;
        status.textContent = message;
        status.hidden = hidden || !message;
      };

      const finish = () => {
        nextUrl = '';
        container.dataset.nextUrl = '';
        container.classList.remove('has-error');
        if (loadButton) loadButton.hidden = true;
        if (sentinel) sentinel.hidden = true;
        setStatus('ALL PRODUCTS LOADED');
        infiniteObserver?.disconnect();
      };

      const updateNextUrl = (incomingContainer) => {
        nextUrl = incomingContainer?.dataset.nextUrl || '';
        container.dataset.nextUrl = nextUrl;

        if (loadButton && nextUrl) {
          loadButton.href = nextUrl;
          loadButton.hidden = false;
        }

        if (!nextUrl) finish();
      };

      const loadNextPage = async () => {
        if (loading || !nextUrl) return false;

        loading = true;
        container.classList.remove('has-error');
        container.setAttribute('aria-busy', 'true');
        setStatus('LOADING…');

        try {
          const response = await fetch(nextUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) throw new Error(`Infinite scroll request failed: ${response.status}`);

          const html = await response.text();
          const incomingDocument = new DOMParser().parseFromString(html, 'text/html');
          const incomingGrid = q('[data-infinite-grid]', incomingDocument);
          const incomingContainer = q('[data-infinite-scroll]', incomingDocument);
          const incomingCards = incomingGrid ? qa(':scope > .product-card', incomingGrid) : [];

          if (!incomingGrid || incomingCards.length === 0) {
            throw new Error('No products were returned for the next collection page.');
          }

          const fragment = document.createDocumentFragment();
          incomingCards.forEach((card) => fragment.appendChild(document.importNode(card, true)));
          grid.appendChild(fragment);

          loadedCount += 1;
          if (collectionPage) collectionPage.dataset.loadedCount = String(loadedCount);

          initializeReveals(grid);
          syncLikeButtons(grid);
          updateNextUrl(incomingContainer);

          if (nextUrl) setStatus('', true);
          return true;
        } catch (error) {
          container.classList.add('has-error');
          if (loadButton) loadButton.hidden = false;
          setStatus('COULD NOT LOAD PRODUCTS');
          return false;
        } finally {
          loading = false;
          container.removeAttribute('aria-busy');
        }
      };

      const loadUntilCount = async (targetCount) => {
        const desiredCount = Math.max(1, Number(targetCount || 1));

        while (loadedCount < desiredCount && nextUrl) {
          const didLoad = await loadNextPage();
          if (!didLoad) break;
        }

        return loadedCount;
      };

      container.loadNextPage = loadNextPage;
      container.loadUntilCount = loadUntilCount;

      loadButton?.addEventListener('click', (event) => {
        event.preventDefault();
        loadNextPage();
      });

      if (nextUrl && sentinel && 'IntersectionObserver' in window) {
        container.classList.add('is-enhanced');
        infiniteObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
        }, { rootMargin: '900px 0px' });
        infiniteObserver.observe(sentinel);
      }
    });
  };

  initializeInfiniteScroll();

  const collectionReturnKey = 'pwm:collection-return:v1';

  const readCollectionReturn = () => {
    try {
      return JSON.parse(sessionStorage.getItem(collectionReturnKey) || 'null');
    } catch (_) {
      return null;
    }
  };

  const writeCollectionReturn = (state) => {
    try {
      sessionStorage.setItem(collectionReturnKey, JSON.stringify(state));
    } catch (_) {
      // Session storage can be unavailable in restricted browser modes.
    }
  };

  const comparableLocation = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      const pathname = url.pathname.replace(/\/$/, '') || '/';
      return `${pathname}${url.search}`;
    } catch (_) {
      return '';
    }
  };

  const initializeCollectionReturn = () => {
    if (isThemeEditor) return;

    const state = readCollectionReturn();
    const productRoot = q('[data-product-root]');
    const breadcrumbLink = q('[data-return-to-collection]');
    const stateIsRecent = state && Date.now() - Number(state.savedAt || 0) < 6 * 60 * 60 * 1000;

    if (
      stateIsRecent &&
      productRoot &&
      breadcrumbLink &&
      state.productHandle === productRoot.dataset.productHandle
    ) {
      breadcrumbLink.href = state.url;
      if (state.title) breadcrumbLink.textContent = state.title;
    }

    const collectionPage = q('[data-collection-page]');
    if (
      !collectionPage ||
      !stateIsRecent ||
      !state.restore ||
      comparableLocation(state.url) !== comparableLocation(window.location.href)
    ) return;

    state.restore = false;
    writeCollectionReturn(state);

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    const targetScroll = Math.max(0, Number(state.scrollY || 0));
    const restoreScroll = () => window.scrollTo({ top: targetScroll, left: 0, behavior: 'auto' });
    const infiniteScroll = q('[data-infinite-scroll]', collectionPage);

    const restorePosition = async () => {
      if (infiniteScroll?.loadUntilCount) {
        await infiniteScroll.loadUntilCount(state.loadedCount || 1);
      }

      requestAnimationFrame(() => requestAnimationFrame(restoreScroll));
      setTimeout(restoreScroll, 120);
      setTimeout(restoreScroll, 450);
      window.addEventListener('load', restoreScroll, { once: true });
    };

    restorePosition();
  };

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-collection-page] [data-product-card-link]');

    if (productLink) {
      const collectionPage = productLink.closest('[data-collection-page]');
      writeCollectionReturn({
        url: window.location.href,
        title: collectionPage?.dataset.collectionTitle || '',
        collectionUrl: collectionPage?.dataset.collectionUrl || '',
        scrollY: window.scrollY,
        loadedCount: Number(collectionPage?.dataset.loadedCount || 1),
        productHandle: productLink.dataset.productHandle || '',
        restore: false,
        savedAt: Date.now()
      });
    }

    const returnLink = event.target.closest('[data-return-to-collection]');
    if (!returnLink) return;

    const currentState = readCollectionReturn();
    const currentProduct = q('[data-product-root]');

    if (
      currentState &&
      currentProduct &&
      currentState.productHandle === currentProduct.dataset.productHandle
    ) {
      currentState.restore = true;
      writeCollectionReturn(currentState);
    }
  });

  initializeCollectionReturn();

  const observer = (!prefersReducedMotion && !isThemeEditor && 'IntersectionObserver' in window)
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 })
    : null;

  const initializeReveals = (scope = document) => {
    const reveals = [];

    if (scope.matches?.('[data-reveal]')) reveals.push(scope);
    reveals.push(...qa('[data-reveal]', scope));

    reveals.forEach((element) => {
      if (prefersReducedMotion || isThemeEditor || !observer) {
        element.classList.add('is-visible');
      } else if (!element.classList.contains('is-visible')) {
        observer.observe(element);
      }
    });
  };

  initializeReveals();

  const initializeProductRecommendations = (scope = document) => {
    const sections = [];

    if (scope.matches?.('[data-product-recommendations]')) sections.push(scope);
    sections.push(...qa('[data-product-recommendations]', scope));

    sections.forEach((section) => {
      if (section.dataset.recommendationsReady === 'true') return;

      const url = section.dataset.recommendationsUrl;
      if (!url) return;

      section.dataset.recommendationsReady = 'true';

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
          return response.text();
        })
        .then((htmlText) => {
          const documentFragment = new DOMParser().parseFromString(htmlText, 'text/html');
          const replacement = q('[data-product-recommendations]', documentFragment);

          if (!replacement || !replacement.innerHTML.trim()) {
            section.hidden = true;
            return;
          }

          section.innerHTML = replacement.innerHTML;
          section.hidden = false;
          initializeReveals(section);
        })
        .catch(() => {
          section.hidden = true;
        });
    });
  };

  initializeProductRecommendations();

  let headerAnimationFrame = 0;
  let headerLayoutObserver = null;

  const updateHeaderState = () => {
    headerAnimationFrame = 0;

    const root = document.documentElement;
    const header = q('[data-site-header]');
    const announcement = q('[data-announcement-stack]');
    const announcementHeight = announcement && !announcement.hidden ? announcement.offsetHeight : 0;

    root.style.setProperty('--announcement-height', `${announcementHeight}px`);

    if (!header) return;

    const threshold = Number(header.dataset.scrollThreshold || 80);
    const isScrolled = window.scrollY > threshold;

    header.classList.toggle('is-scrolled', isScrolled);
    header.classList.toggle('is-at-top', !isScrolled);

    const rect = header.getBoundingClientRect();
    root.style.setProperty('--header-height', `${Math.round(rect.height)}px`);
    root.style.setProperty('--drawer-top', `${Math.max(0, Math.round(rect.bottom))}px`);

    if (!header.classList.contains('is-ready')) {
      requestAnimationFrame(() => header.classList.add('is-ready'));
    }
  };

  const requestHeaderUpdate = () => {
    if (headerAnimationFrame) return;
    headerAnimationFrame = requestAnimationFrame(updateHeaderState);
  };

  const observeHeaderLayout = () => {
    if (!('ResizeObserver' in window)) return;

    if (!headerLayoutObserver) {
      headerLayoutObserver = new ResizeObserver(requestHeaderUpdate);
    }

    headerLayoutObserver.disconnect();

    const header = q('[data-site-header]');
    const announcement = q('[data-announcement-stack]');

    if (header) headerLayoutObserver.observe(header);
    if (announcement && !announcement.hidden) headerLayoutObserver.observe(announcement);
  };

  let menuScrollY = 0;

  const lockMenuScroll = () => {
    if (document.body.classList.contains('menu-open')) return;

    menuScrollY = window.scrollY;
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

    document.documentElement.style.setProperty('--menu-scrollbar-width', `${scrollbarWidth}px`);
    document.documentElement.classList.add('menu-open');
    document.body.classList.add('menu-open');
    document.body.style.top = `-${menuScrollY}px`;
  };

  const unlockMenuScroll = () => {
    if (!document.body.classList.contains('menu-open')) return;

    document.documentElement.classList.remove('menu-open');
    document.body.classList.remove('menu-open');
    document.body.style.removeProperty('top');
    document.documentElement.style.removeProperty('--menu-scrollbar-width');
    window.scrollTo(0, menuScrollY);
  };

  const syncMenuState = () => {
    const menuIsOpen = Boolean(q('[data-header-menu][open]'));

    if (menuIsOpen) {
      lockMenuScroll();
    } else {
      unlockMenuScroll();
    }

    requestHeaderUpdate();
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-close-details]');
    if (closeButton) {
      const details = closeButton.closest('details');
      if (details) details.removeAttribute('open');
      syncMenuState();
      return;
    }

    const announcementClose = event.target.closest('[data-announcement-close]');
    if (announcementClose) {
      const announcement = announcementClose.closest('[data-announcement-stack]');
      if (announcement) announcement.hidden = true;
      observeHeaderLayout();
      requestHeaderUpdate();
      return;
    }

    const menuLink = event.target.closest('[data-header-menu] .mobile-menu__panel a');
    if (menuLink) {
      const menu = menuLink.closest('[data-header-menu]');
      if (menu) menu.removeAttribute('open');
      syncMenuState();
    }
  });

  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('[data-header-menu]')) syncMenuState();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openMenu = q('[data-header-menu][open]');
    if (!openMenu) return;

    openMenu.removeAttribute('open');
    q('summary', openMenu)?.focus();
    syncMenuState();
  });

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate);
  window.addEventListener('load', requestHeaderUpdate, { once: true });

  observeHeaderLayout();
  updateHeaderState();

  document.addEventListener('shopify:section:load', (event) => {
    initializeReveals(event.target);
    initializeProductCarousels(event.target);
    initializeSizeCharts(event.target);
    initializeProductRecommendations(event.target);
    initializeInfiniteScroll(event.target);
    initializeLikes(event.target);
    observeHeaderLayout();
    requestHeaderUpdate();
  });
})();
